import { FaSpinner } from 'react-icons/fa';
import ActionButton from '../ActionButton';

// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface BureauConfig {
    code: string;
    name: string;
}

interface BatchActionBarProps {
    selectedCount: number;
    isReprocessing: boolean;
    showReprocess: boolean;
    hasFilters: boolean;
    bureaus: BureauConfig[];
    onReprocess: () => void;
    onClearFilters: () => void;
    onViewAnalysis: () => void;
    onRefreshPaf: () => void;
    onContinueAnalysis: () => void;
    onRunSingleBureau: (bureauCode: string) => void;
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function BatchActionBar({
    selectedCount,
    isReprocessing,
    showReprocess,
    hasFilters,
    bureaus,
    onReprocess,
    onClearFilters,
    onViewAnalysis,
    onRefreshPaf,
    onContinueAnalysis,
    onRunSingleBureau,
}: BatchActionBarProps) {
    return (
        <div className="flex gap-2">
            {showReprocess && (
                <ActionButton variant="warning" size="sm" disabled={isReprocessing} onClick={onReprocess}
                    icon={isReprocessing ? <FaSpinner className="animate-spin" /> : undefined}
                >
                    {isReprocessing ? 'Reprocessando...' : 'Reprocessar Lote'}
                </ActionButton>
            )}
            {hasFilters && (
                <ActionButton variant="secondary" size="sm" onClick={onClearFilters}>
                    Limpar filtros
                </ActionButton>
            )}
            <ActionButton variant="secondary" size="sm" onClick={onViewAnalysis}>
                Ver Análise
            </ActionButton>

            {selectedCount > 0 && (
                <>
                    <ActionButton variant="secondary" size="sm" onClick={onRefreshPaf}>
                        Atualizar PAF ({selectedCount})
                    </ActionButton>
                    <ActionButton variant="primary" size="sm" onClick={onContinueAnalysis}>
                        Continuar Análise ({selectedCount})
                    </ActionButton>
                    {/* select com cara de botão escuro: chevron branco próprio, porque o global
                        (cinza, em index.css) não tem contraste sobre o fundo gray-600 */}
                    <select
                        onChange={(e) => {
                            const bureau = e.target.value;
                            if (!bureau) return;
                            e.target.value = '';
                            onRunSingleBureau(bureau);
                        }}
                        className="appearance-none px-3 py-1.5 pr-8 text-sm bg-gray-600 dark:bg-gray-500 text-white rounded hover:bg-gray-700 dark:hover:bg-gray-600 dark:border-slate-600 bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22M2%204l4%204%204-4%22%2F%3E%3C%2Fsvg%3E')] bg-no-repeat bg-[right_0.5rem_center]"
                        defaultValue=""
                    >
                        <option value="">Rodar em Birô...</option>
                        {bureaus.map(b => (
                            <option key={b.code} value={b.code}>{b.name}</option>
                        ))}
                    </select>
                </>
            )}
        </div>
    );
}
